import React from 'react';

import { OneyLabel } from './OneyLabel';

export const OneySelector = ({ price, label }) => {
  return (
    <div className="flex items-start justify-start gap-4 md:items-center md:justify-center">
      <OneyLabel
        price={{ total: { value: price } }}
        iconClassname="text-sienna"
        payingLabel={label}
      />
    </div>
  );
};
